import { atom } from 'recoil';

type DateRange = {
  startDate: string | null;
  endDate: string | null;
};

export const ifreaMediaAnalyticsDateRangeState = atom<DateRange>({
  key: 'ifreaMediaAnalyticsDateRangeState',
  default: { startDate: null, endDate: null }
});